<h2 mat-dialog-title class="text-align-center"><mat-icon>lock</mat-icon></h2>
<mat-dialog-content>
  <div>
    <mat-spinner *ngIf="!privacyPolicy"></mat-spinner>
    <div [innerHTML]="privacyPolicy"></div>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-flat-button mat-dialog-close cdkFocusInitial>Close</button>
</mat-dialog-actions>
